import { IDocument } from '@lib-shared/types/Document';

export interface IUpdateDocumentState {
  updating: boolean;
  updateFailed: boolean;
  updatedDocument: IDocument;
  originalDocument: IDocument;
}

export enum EUpdateDocumentAction {
  UpdatePageOrder = 'updatePageOrder',
  UpdatePageOrderSuccess = 'updatePageOrderSuccess',
  UpdatePageOrderFailed = 'updatePageOrderFailed',

  Reset = 'reset',
}

export enum EUpdateDocumentMutation {
  SetState = 'setState',
  SetUpdating = 'setUpdating',
  SetUpdatedDocument = 'setUpdatedDocument',
  SetOriginalDocument = 'setOriginalDocument',
  SetUpdateFailed = 'setUpdateFailed',
}
